import React from 'react';
import Box from '@material-ui/core/Box';
import Chip from '@material-ui/core/Chip';
import Typography from '@material-ui/core/Typography';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import useSnack from 'hooks/useSnack';
import { makeStyles } from '@material-ui/core/styles';

const VARIABLES = [
  {
    label: 'Preferred/First Name',
    value: '{{name}}',
  },
  {
    label: 'First name',
    value: '{{first_name}}',
  },
  {
    label: 'Last name',
    value: '{{last_name}}',
  },
];

const useStyles = makeStyles((theme) => ({
  chip: {
    marginRight: theme.spacing(1),
    marginBottom: theme.spacing(1),
  },
}));

const Variable = ({ label, value }) => {
  const snack = useSnack();
  const classes = useStyles();
  return (
    <CopyToClipboard
      text={value}
      onCopy={() => snack.success('Copied to clipboard.')}
    >
      <Chip
        size={'small'}
        classes={{ root: classes.chip }}
        label={label}
        clickable
      />
    </CopyToClipboard>
  );
};

const Variables = ({}) => {
  return (
    <Box>
      <Typography gutterBottom variant="caption" component="p">
        Click on the variable to copy and paste in your message.
      </Typography>
      <Box>
        {VARIABLES.map((key) => (
          <Variable label={key.label} value={key.value} key={key.value} />
        ))}
      </Box>
    </Box>
  );
};

export default Variables;
